export enum FormType {
  CREATE,
  UPDATE,
}
export interface IRequestFormProps {
  index: number;
  length: number;
  type?: FormType;
}
